import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Form, Input } from 'antd';
import HeaderBack from '../../../../components/mobile/HeaderBack';
import { ReactComponent as PhoneSvg } from '../../../../assets/icons/user-account/phone.svg';

const { Title } = Typography;

function MobileUseDifferentNumberScreen() {
  const { t } = useTranslation(['sign-up', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/sign-up/loggedin')
  }

  const onCallMe = () => {

  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('sign-up:returnToPreviousPage')}
        title={t('sign-up:useDiffrentNumber')}
        subtitle={t('sign-up:pleaseEnterMobileNumber')}
      />
      <Form.Item>
        <Input placeholder={t('sign-up:mobileNumber')} />
      </Form.Item>
      <Button
        htmlType="button"
        type="primary"
        size="large"
        onClick={onCallMe}
        block
      >
        <p style={styles.rowButton}>
          <PhoneSvg style={{ marginRight: 5 }}/>{t('sign-up:callMeOnThisNumber')}
        </p>
      </Button>
    </>
  );
}

const styles = {
  divider: {
    fontSize: 14,
    fontWeight: 28,
    color: '#999999',
    margin: 0
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
}

export default MobileUseDifferentNumberScreen;
